import {
  Chat,
  ApartmentRounded,
  AssessmentRounded,
  PeopleRounded,
  Dashboard,
  CheckCircle,
  Inventory,
  Key,
  ShoppingCartRounded,
  HomeSharp,
  Description,
  EventRounded,
  MenuBookRounded,
  MapsHomeWork,
  Bolt,
  Newspaper,
  CreditCard,
  RoomService,
  Payments,
  AddHomeWork,
  FindInPageRounded,
  Draw,
  AccountCircle,
} from '@mui/icons-material';
import SideBarContent, {
  SideBarItem,
  UserSideBarContentProps,
} from '../../layout/SideBar/SideBarContent';
import {useFeatures} from '@/hooks/useFeatures/useFeatures';
import {useGetClientPaymentsEnabledQuery} from '@/generated/graphql';
import {CategoryItem} from '@/layout/SideBar/SideBarAccordian';
import {useReferencingEnabled} from './useReferencingEnabled/useReferencingEnabled';

type ManagerSideBarContentProps = UserSideBarContentProps;

export const ManagerSideBarContent = (props: ManagerSideBarContentProps) => {
  const [features] = useFeatures();
  const {data} = useGetClientPaymentsEnabledQuery();
  const paymentsEnabled = data?.getClient?.paymentsEnabled;
  const referencingEnabled = useReferencingEnabled();

  const items: (SideBarItem | CategoryItem)[] = [
    {
      url: '/dashboard',
      label: 'Dashboard',
      icon: <Dashboard fontSize="small" />,
    },
    {
      label: 'Communities',
      icon: <MapsHomeWork fontSize="small" />,
      items: [
        {
          url: '/communities',
          label: 'Overview',
          icon: <ApartmentRounded fontSize="small" />,
        },
        {
          url: '/homes',
          label: 'Homes',
          icon: <HomeSharp fontSize="small" />,
        },
        {
          url: '/contact-profiles',
          label: 'Contacts',
          icon: <AccountCircle fontSize="small" />,
        },
        {
          url: '/groups',
          label: 'Groups',
          icon: <PeopleRounded fontSize="small" />,
        },
        {
          url: '/verification',
          label: 'Applicants',
          icon: <CheckCircle fontSize="small" />,
        },
      ],
    },
    {
      label: 'Engagement',
      icon: <Bolt fontSize="small" />,
      items: [
        {
          url: '/updates',
          label: 'Newsfeed',
          icon: <Newspaper fontSize="small" />,
        },
        {
          url: '/messages',
          label: 'Messages',
          icon: <Chat fontSize="small" />,
        },
        {
          url: '/surveys',
          label: 'Surveys',
          icon: <AssessmentRounded fontSize="small" />,
        },
        {
          url: '/documents',
          label: 'Documents',
          icon: <Description fontSize="small" />,
        },
        {
          url: '/events',
          label: 'Events',
          icon: <EventRounded fontSize="small" />,
        },
        {
          url: '/facilities',
          label: 'Facilities',
          icon: <MenuBookRounded fontSize="small" />,
        },
      ],
    },
    ...((features.CommunityProducts && paymentsEnabled) ||
    features.LeaseholderPayments
      ? [
          {
            label: 'Payments',
            icon: <CreditCard fontSize="small" />,
            items: [
              ...(features.CommunityProducts && paymentsEnabled
                ? [
                    {
                      url: '/community-products',
                      label: 'Products',
                      icon: <ShoppingCartRounded fontSize="small" />,
                    },
                  ]
                : []),
              ...(features.LeaseholderPayments
                ? [
                    {
                      url: '/payments',
                      label: 'Account',
                      icon: <Payments fontSize="small" />,
                    },
                  ]
                : []),
            ],
          },
        ]
      : []),
    {
      label: 'Concierge',
      icon: <RoomService fontSize="small" />,
      items: [
        {
          url: '/packages',
          label: 'Packages',
          icon: <Inventory fontSize="small" />,
        },
        {
          url: '/keys',
          label: 'Keys',
          icon: <Key fontSize="small" />,
        },
        {
          url: '/visitors',
          label: 'Visitors',
          icon: <Draw fontSize="small" />,
        },
      ],
    },
    ...(referencingEnabled
      ? [
          {
            label: 'Onboarding',
            icon: <AddHomeWork fontSize="small" />,
            items: [
              {
                url: '/referencing',
                label: 'Referencing',
                icon: <FindInPageRounded fontSize="small" />,
              },
            ],
          },
        ]
      : []),
  ];

  return (
    <SideBarContent items={items} onClose={props.onClose}>
      {props.children}
    </SideBarContent>
  );
};
